let partners = {};

['mobilleo', 'gohi', 'kinto', 'derbygo', 'heart', 'gosurrey', 'swift', 'movezero', 'tfwm'].forEach(partnerName => {
  partners[partnerName] = require(`./${partnerName}.js`).default
})

export default { ...partners }
